import { App } from '@prisma/client';

import { applicationHref } from 'frontend/api/trpc';

export function getPublicAppUrl(app: App) {
  return `${applicationHref}explore/${app.shortName}`;
}
